import { BaseConfig } from '../ServiceConfig';

export interface FirebaseConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.FirebaseServiceConfigData';
  projectId: string;
  applicationId: string;
  apiKey: string;
  databaseUrl: string;
  storageBucket: string;
  gcmSenderId: string;
}

export const FirebaseConfigurationFields: (keyof FirebaseConfiguration)[] = [
  'projectId',
  'applicationId',
  'apiKey',
  'databaseUrl',
  'storageBucket',
  'gcmSenderId',
];

export const BlankFirebaseConfiguration: FirebaseConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.FirebaseServiceConfigData',
} as FirebaseConfiguration;
